import React from 'react';
import { Link } from 'react-router-dom';
import PublicNavbar from '../../components/PublicNavbar';

const CookiePolicy = () => {
  return (
    <>
      <PublicNavbar />
      <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 py-12 px-4">
        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">Política de Cookies</h1>
          
          <div className="space-y-6 text-gray-600">
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">1. O que são Cookies?</h2>
              <p>Cookies são pequenos arquivos de texto armazenados em seu dispositivo quando você visita nosso site.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Tipos de Cookies que Utilizamos</h2>
              <ul className="list-disc pl-6 mt-2">
                <li>Cookies essenciais: necessários para o funcionamento do site</li>
                <li>Cookies de preferências: armazenam suas configurações</li>
                <li>Cookies analíticos: nos ajudam a melhorar o site</li>
                <li>Cookies de marketing: personalizam anúncios (opcional)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Gerenciamento de Cookies</h2>
              <p>Você pode gerenciar suas preferências de cookies a qualquer momento:</p>
              <ul className="list-disc pl-6 mt-2">
                <li>Através das configurações do seu navegador</li>
                <li>Usando nosso painel de preferências de cookies</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Cookies de Terceiros</h2>
              <p>Alguns cookies são definidos por serviços de terceiros que aparecem em nossas páginas.</p>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link 
              to="/"
              className="text-purple-600 hover:text-purple-700 font-medium"
            >
              ← Voltar para a página inicial
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookiePolicy;
